import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React, { Component } from "react";

import { logout } from "./Store/Actions";
import { store } from "./Store/configureStore";
import FlexBox from "./components/common/FlexBox";
import { Button } from "./components/common/Buttons";
import { Body1 } from "./components/common/Headings";
import { bugsnagOnError } from "./utils/bugsnagFilters";
import { bugsnagKey } from "./variable";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount() {
    Bugsnag.start({
      apiKey: bugsnagKey,
      appVersion: "2.0.0",
      plugins: [new BugsnagPluginReact()],
      onError: bugsnagOnError,
    });
    Bugsnag.getPlugin("react").createErrorBoundary(React);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log("Error occured", error, errorInfo);
    Bugsnag.notify(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <FlexBox column justify="center" align="center">
          <lottie-player
            src="https://assets4.lottiefiles.com/packages/lf20_i9al2qxo.json"
            background="transparent"
            speed="1"
            style={{ width: "50vw", height: "50vh" }}
            loop
            autoplay
          />
          <Body1 margin="0 0 4rem 0" bold fontSize="1.5rem">
            Something went wrong
          </Body1>

          <Button onClick={() => (window.location.href = "/dashboard")}>
            Go to Dashboard
          </Button>
          {typeof window !== "undefined" && !window?.ReactNativeWebView && (
            <Button onClick={() => store?.dispatch?.(logout())}>Relogin</Button>
          )}
        </FlexBox>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
